export default "__VITE_ASSET__B10d_7Y7__"